import axios from 'axios';

export const getBanner = () => {

    return axios.post(`${process.env.REACT_APP_HOST_API}/banner/page`, {
        page : 1,
        per_page : 10
    });
};